
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetosataracab() {



    const cardData =
    {
        keyword: 'Pune to Satara Cab',
        heading: 'Platinum24 Cabs: Pune to Satara Cab',
        headingDescription: ' Platinum24 Cabs offers dependable Pune to Satara Cab services, ideal for business travel, family visits, and sightseeing trips. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a comfortable and safe journey with spacious seating and air-conditioned comfort. With professional chauffeurs familiar with the Pune–Satara route, we guarantee punctual pickups, smooth highway travel, and a hassle-free experience. Whether you’re heading to Kaas Plateau, Ajinkyatara Fort, Thoseghar Waterfalls, or Satara city, Platinum24 Cabs provides affordable fares, transparent pricing, and reliable cab service for your Pune to Satara travel needs.',

        top: 'Top Places to Visit in Satara with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Kaas Plateau (Valley of Flowers)",
    "description": "Kaas Plateau, a UNESCO World Natural Heritage Site near Satara, is famous for its seasonal bloom of wildflowers. From August to October, the plateau turns into a colorful carpet of orchids, lilies, and rare species. Nature lovers and photographers flock here for its breathtaking landscapes. The site is carefully protected, ensuring eco-friendly tourism. Misty monsoons make it even more enchanting. Kaas Plateau is Satara’s crown jewel of natural beauty."
  },
  {
    "title": "Ajinkyatara Fort",
    "description": "Ajinkyatara Fort, perched at 3,300 feet, offers panoramic views of Satara city. Built in the 16th century, it played a strategic role in Maratha history. The fort has bastions, gates, and temples like Hanuman and Devi shrines. Trekking up is moderately easy and rewarding with scenic vistas. It is especially popular during monsoon. Ajinkyatara Fort is Satara’s living reminder of Maratha valor."
  },
  {
    "title": "Thoseghar Waterfall",
    "description": "Thoseghar Waterfall near Satara is a breathtaking cascade that plunges from over 1,000 feet. Surrounded by lush green hills, it is one of Maharashtra’s tallest waterfalls. Monsoon transforms it into a thundering natural wonder. Visitors enjoy viewpoints and picnic spots nearby. Photographers capture its majestic flow and misty ambiance. Thoseghar is Satara’s monsoon paradise."
  },
  {
    "title": "Sajjangad Fort",
    "description": "Sajjangad Fort is a revered spiritual site, known as the final resting place of Sant Ramdas, spiritual guide of Chhatrapati Shivaji Maharaj. Pilgrims visit for its temples and ashrams, where bhajans and prayers create a divine aura. The fort also offers scenic views of valleys and lakes. Devotees believe visiting here grants peace and blessings. Sajjangad is Satara’s sacred blend of history and spirituality."
  },
  {
    "title": "Koyna Dam & Wildlife Sanctuary",
    "description": "Koyna Dam, built on the Koyna River, is one of India’s largest hydroelectric projects. Surrounded by the Western Ghats, it creates the beautiful Shivsagar Lake. The nearby Koyna Wildlife Sanctuary is home to tigers, leopards, and diverse flora and fauna. Monsoon enhances the greenery and water levels, making it a scenic retreat. Boating and nature walks are popular here. Koyna is Satara’s powerhouse of beauty and energy."
  },
  {
    "title": "Natraj Mandir, Satara",
    "description": "Natraj Mandir in Satara is a unique temple dedicated to Lord Shiva in the form of Nataraja, inspired by the famous Chidambaram temple of Tamil Nadu. Its Dravidian-style architecture and intricate carvings attract devotees and tourists. The temple is serene and spiritually uplifting. Festivals like Mahashivratri draw large crowds. Surrounded by peaceful ambiance, it is ideal for meditation. Natraj Mandir is Satara’s sacred cultural landmark."
  },
  {
    "title": "Kaas Lake",
    "description": "Kaas Lake, located near the famous Kaas Plateau, is a tranquil water body surrounded by greenery. It was originally built as a reservoir for Satara. The calm environment makes it ideal for relaxation and photography. Migratory birds can be spotted during certain seasons. Tourists often combine a visit with the flower valley. Kaas Lake is Satara’s peaceful natural retreat."
  },
  {
    "title": "Chalkewadi Windmill Farms",
    "description": "Chalkewadi Windmill Farms, near Thoseghar, feature hundreds of giant windmills dotting the hills. It is one of Maharashtra’s largest wind energy projects. The landscape looks surreal, especially during monsoon with mist and waterfalls around. Tourists enjoy scenic drives and photography here. The site is peaceful yet futuristic in appeal. Chalkewadi is Satara’s blend of green energy and natural charm."
  },
  {
    "title": "Jarandeshwar Temple & Caves",
    "description": "Jarandeshwar Temple near Satara is dedicated to Lord Shiva and is located near ancient Buddhist caves. The caves have rock-cut architecture and historical significance. Pilgrims visit the temple for its divine aura and natural setting. The site is surrounded by forests and hills, making it serene. It attracts both history lovers and devotees. Jarandeshwar is Satara’s hidden gem of spirituality and heritage."
  },
  {
    "title": "Yamai Devi Temple, Aundh",
    "description": "Located near Satara, the Yamai Devi Temple at Aundh is an ancient and highly revered shrine. Dedicated to Goddess Yamai, it is an important pilgrimage site in Maharashtra. Devotees climb steps to reach the temple perched on a hilltop. The temple is especially vibrant during Navratri. It also offers panoramic views of the surrounding landscape. Yamai Devi Temple is Satara’s divine abode of faith and devotion."
  }
],



   "services": [
    {
      "name": "Pune to Satara Taxi Service",
      "description": "Travel from Pune to Satara comfortably and safely with our dedicated Pune to Satara Taxi Service. Whether you're visiting for business, leisure, or pilgrimage, our fleet of well-maintained vehicles and experienced drivers ensure a smooth and hassle-free journey. Enjoy door-to-door service, punctual pickups, and flexible scheduling tailored to your travel plans. The route between Pune and Satara is scenic, and with our taxi service, you can relax and enjoy the views without the stress of driving. Ideal for solo travelers, families, and groups looking for a reliable transport option, our service offers competitive pricing and excellent customer support."
    },
    {
      "name": "Satara Cab from Pune",
      "description": "Our Satara Cab from Pune service provides a seamless travel experience with comfortable, clean vehicles suited for short and long-distance trips. Skip the crowded buses and trains and opt for a private cab that offers personalized travel with freedom to stop and explore en route. Whether you’re on a weekend trip or an official visit, we ensure timely pickups and smooth journeys, with drivers who are well-acquainted with the Pune-Satara route and local landmarks. Book your Satara cab today for a convenient and enjoyable ride."
    },
    {
      "name": "Pune Satara Taxi Booking",
      "description": "Booking your taxi from Pune to Satara is made simple with our efficient and user-friendly platform. You can reserve your ride online or via phone, with instant confirmation and transparent pricing. Our Pune Satara Taxi Booking service offers multiple vehicle options—from economical sedans to spacious SUVs—catering to different group sizes and budgets. With flexible cancellation policies and 24/7 customer service, your trip planning is stress-free from start to finish."
    },
    {
      "name": "Taxi Service Pune to Satara",
      "description": "Our Taxi Service from Pune to Satara is designed to provide comfortable, safe, and punctual travel for all kinds of passengers. Whether you need a quick one-way transfer or a round trip, we customize our services to fit your needs. Our drivers are professional, courteous, and trained to handle the Pune-Satara route efficiently. Enjoy smooth rides in sanitized vehicles equipped with modern amenities, making your journey pleasant and relaxing. This service is perfect for business travelers, tourists, and families visiting Satara’s famous forts, waterfalls, and cultural sites."
    },
    {
      "name": "Satara Cab Rental Pune",
      "description": "Rent a cab from Pune to Satara with confidence, knowing you’ll receive top-notch service throughout your trip. Our Satara Cab Rental Pune offers hourly and daily packages that allow you to explore Satara and surrounding areas at your own pace. Whether it’s a day trip or a longer tour, we provide reliable cabs driven by experienced chauffeurs who prioritize your comfort and safety. Our rental packages are competitively priced, and our vehicles are regularly serviced to maintain high standards of cleanliness and performance."
    },
    {
      "name": "Pune to Satara Taxi Fare",
      "description": "Get transparent and affordable Pune to Satara Taxi Fare rates that suit all budgets. Our pricing is based on the distance, type of vehicle, and duration of the trip, ensuring you pay only for the services you use. We provide detailed fare estimates before you finalize your booking, with no hidden charges or surprise fees. Whether you select an economical sedan or a premium SUV, our taxi fares offer great value for a comfortable and hassle-free travel experience."
    },
    {
      "name": "Pune Satara Private Taxi",
      "description": "Opt for a Pune Satara Private Taxi to enjoy exclusive, door-to-door service without any stops or shared rides. Perfect for families, corporate clients, and groups wanting privacy and personalized attention, our private taxis offer a peaceful travel environment with flexibility in scheduling. Our courteous drivers assist with luggage and can make stops as per your request, enhancing your travel convenience and comfort. Experience a premium journey with full control over your itinerary."
    },
    {
      "name": "Satara Cab Packages Pune",
      "description": "Choose from a range of Satara Cab Packages from Pune tailored to meet diverse travel needs. Our packages include round-trip rentals, multi-day tours, and weekend getaway deals, all designed to provide cost-effective and convenient options. These packages often cover tolls, driver allowances, and parking, offering you an all-inclusive solution. Whether you want to explore Satara’s heritage sites or natural beauty spots, our packages are flexible and customizable to maximize your travel experience."
    },
    {
      "name": "Pune to Satara One Way Cab",
      "description": "Our Pune to Satara One Way Cab service is perfect for travelers seeking a simple, direct transfer with no return trip. Ideal for those continuing their journey from Satara to other destinations, our one-way taxis provide reliable and punctual service. You can choose from a variety of vehicle options and enjoy a comfortable ride without the hassle of round-trip bookings or waiting time. Enjoy complete flexibility and convenience with our one-way cab service."
    },
    {
      "name": "Satara Taxi Charges Pune",
      "description": "Satara Taxi Charges from Pune are competitively priced to ensure you get excellent value without compromising on quality. Charges depend on vehicle type, distance, and rental duration. We provide clear, upfront pricing details during the booking process, ensuring transparency. Our affordable rates combined with professional service make us a preferred choice for Pune to Satara travelers seeking convenience and comfort."
    },
    {
      "name": "Pune to Satara Taxi Hire",
      "description": "Hire a taxi from Pune to Satara effortlessly with our flexible and customer-centric taxi hire service. Choose from a wide selection of cars including hatchbacks, sedans, SUVs, and tempo travelers based on your group size and travel preferences. Our taxi hire service guarantees timely pickups, safe journeys, and well-maintained vehicles for a pleasant trip experience. Our team is ready to assist with personalized recommendations to ensure the best travel solution for you."
    },
    {
      "name": "Satara Cab for Weekend Trips Pune",
      "description": "Plan your weekend escape to Satara with our specialized cab services designed for weekend trips from Pune. Whether you want to explore the famous Ajinkyatara Fort, Kaas Plateau, or the beautiful waterfalls, our weekend cab packages offer round-trip options with flexible scheduling and competitive pricing. Travel comfortably with professional drivers who know the best sightseeing spots, ensuring you make the most of your weekend getaway without any transport worries."
    },
    {
      "name": "Pune to Satara Outstation Taxi",
      "description": "Our Pune to Satara Outstation Taxi service is ideal for longer journeys, multi-day tours, and extended trips. Enjoy a comfortable ride with a reliable taxi service that offers well-maintained vehicles equipped with modern amenities. Our experienced drivers are knowledgeable about the routes and can assist with itinerary planning, local sightseeing, and stops along the way. Perfect for families, groups, and business travelers needing dependable outstation transport."
    },
    {
      "name": "Satara Taxi with Driver Pune",
      "description": "Experience the convenience of Satara Taxi with Driver from Pune, where professional chauffeurs take care of the driving so you can relax and enjoy your trip. Our drivers are polite, punctual, and knowledgeable about the Satara region, ensuring safe and efficient travel. Whether you want a point-to-point transfer or a day rental with sightseeing, our driver services are flexible and designed to provide a comfortable, stress-free journey."
    },
    {
      "name": "Taxi Service Pune to Satara",
      "description": "Count on our Taxi Service from Pune to Satara for reliable, timely, and affordable transportation. Our commitment to customer satisfaction means you receive clean vehicles, professional drivers, and excellent service from the moment you book to the end of your trip. Suitable for all kinds of travelers, from tourists to corporate clients, our service ensures a smooth and enjoyable travel experience between Pune and Satara."
    }
  ],
  "tableData": [
    ["Pune to Satara Taxi Service", "Satara Cab from Pune"],
    ["Pune Satara Taxi Booking", "Taxi Service Pune to Satara"],
    ["Satara Cab Rental Pune", "Pune to Satara Taxi Fare"],
    ["Pune Satara Private Taxi", "Satara Cab Packages Pune"],
    ["Pune to Satara One Way Cab", "Satara Taxi Charges Pune"],
    ["Pune to Satara Taxi Hire", "Satara Cab for Weekend Trips Pune"],
    ["Pune to Satara Outstation Taxi", "Satara Taxi with Driver Pune"],
    ["Taxi Service Pune to Satara", "—"]
  ],


        "whychoose": [
    {
      "WhyChooseheading": "Reliable Pune to Satara Cab Service",
      "WhyChoosedescription": "Platinum24 Cabs offers comfortable and timely cab rides from Pune to Satara for all your travel needs."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with Pune-Satara Routes",
      "WhyChoosedescription": "Our skilled drivers know the best routes to ensure a smooth and safe journey to Satara."
    },
    {
      "WhyChooseheading": "Clean and Spacious Vehicles for Comfortable Travel",
      "WhyChoosedescription": "Travel in well-maintained, air-conditioned cabs with ample space for passengers and luggage."
    },
    {
      "WhyChooseheading": "Flexible Booking for One-Way and Round Trips",
      "WhyChoosedescription": "Choose packages tailored to your travel plans from Pune to Satara and back."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy upfront pricing that includes fuel, tolls, and driver allowances for a hassle-free experience."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Easy Booking",
      "WhyChoosedescription": "Our support team is available around the clock to assist with your cab bookings and queries."
    },
    {
      "WhyChooseheading": "Ideal for Family Trips, Corporate Travel, and Group Outings",
      "WhyChoosedescription": "Our Pune to Satara cab services cater to all types of travelers and occasions."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options to Suit Your Needs",
      "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, or tempo travellers based on your group size and preferences."
    }
  ]





































    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs provide cab services from Pune to Satara?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable cab services for travel between Pune and Satara.',
    },
    {
        question: 'How can I book a Pune to Satara cab with Platinum24 Cabs?',
        answer: 'You can easily book your Pune to Satara cab through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Satara trips?',
        answer: 'We offer a variety of vehicles including sedans, SUVs, and tempo travellers to suit your travel preferences and group size.',
    },
    {
        question: 'Are the drivers experienced for Pune to Satara routes?',
        answer: 'Yes, all our drivers are professional, experienced, and knowledgeable about the Pune to Satara route.',
    },
    {
        question: 'Can I book a round trip cab from Pune to Satara?',
        answer: 'Absolutely! We provide round-trip cab services with flexible scheduling to accommodate your travel plans.',
    },
    {
        question: 'What is included in the fare for Pune to Satara cab services?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for Pune to Satara rides?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points along the Pune-Satara route.',
    },
    {
        question: 'Are safety measures followed during Pune to Satara cab rides?',
        answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety protocols for your protection.',
    },
    {
        question: 'Is it possible to hire a cab for multiple days for Pune to Satara travel?',
        answer: 'Yes, we offer hourly and multi-day rental packages tailored to your travel needs.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate taxi services from Pune to Satara?',
        answer: 'Yes, we offer customized corporate travel solutions including priority support and flexible billing for Pune to Satara routes.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ashok More',
        feedback: 'The Pune to Satara cab service by Platinum24 Cabs was punctual and comfortable. Highly recommended.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Priyanka Joshi',
        feedback: 'Excellent service from Pune to Satara. The driver was professional and the vehicle was well-maintained.',
        rating: 5,
    },
];



















































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];







const puneSataraSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Affordable and reliable Pune to Satara Cab Service offering private taxis, one-way trips, weekend getaway cabs, and outstation taxi rentals with driver.",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Pune to Satara Cab Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Pune to Satara Taxi Service"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Satara Cab Rental Pune"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Pune to Satara One Way Cab"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Satara Cab for Weekend Trips"
        }
      }
    ]
  },
  "telephone": "+91-XXXXXXXXXX",
  "serviceType": [
    "Pune to Satara Taxi Service",
    "Satara Cab from Pune",
    "Pune Satara Taxi Booking",
    "Taxi Service Pune to Satara",
    "Satara Cab Rental Pune",
    "Pune to Satara Taxi Fare",
    "Pune Satara Private Taxi",
    "Satara Cab Packages Pune",
    "Pune to Satara One Way Cab",
    "Satara Taxi Charges Pune",
    "Pune to Satara Taxi Hire",
    "Satara Cab for Weekend Trips Pune",
    "Pune to Satara Outstation Taxi",
    "Satara Taxi with Driver Pune",
    "Taxi Service Pune to Satara"
  ]
};








    return (
        <div>

<Helmet>
  <title>Pune to Satara Cab Service | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Affordable and reliable Pune to Satara Cab Service offering private taxis, one-way trips, weekend getaway cabs, and outstation taxi rentals with driver."
  />
  <meta
    name="keywords"
    content="Pune to Satara Taxi Service, Satara Cab from Pune, Pune Satara Taxi Booking, Taxi Service Pune to Satara, Satara Cab Rental Pune, Pune to Satara Taxi Fare, Pune Satara Private Taxi, Satara Cab Packages Pune, Pune to Satara One Way Cab, Satara Taxi Charges Pune, Pune to Satara Taxi Hire, Satara Cab for Weekend Trips Pune, Pune to Satara Outstation Taxi, Satara Taxi with Driver Pune, Taxi Service Pune to Satara"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneSataraSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/52.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetosataracab;